import { Order, OrderItem, OrderItemGroup } from "@lemmonhq/types";

export const calculateOrderItemTotal = (
  item: OrderItem | OrderItemGroup,
  qty?: number,
): number => {
  const basePrice = item.price;
  const bundlePrice =
    item.bundles?.reduce((total, bundle) => total + bundle.price, 0) || 0;
  return (
    (basePrice + bundlePrice) *
    (qty !== undefined && Number.isFinite(qty) ? qty : item.quantity)
  );
};
export const calculateOrderTotal = (order: Order): number => {
  let sum = (order.items || []).reduce(
    (sum, item) => calculateOrderItemTotal(item) + sum,
    0,
  );
  if (order.delivery_fee) {
    sum = sum + order.delivery_fee;
  }
  return sum;
};
